// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ua-page {
  padding: 18px 22px 26px;
  font-family: 'Unilever Shilling', sans-serif;
  font-size: 0.875rem;
  color: #111111;
}

.ua-shell {
  /* max-width: 1500px; */
  margin: 0 auto;
}

.ua-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
}

.ua-hero__title {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.ua-hero__mark {
  width: 52px;
  height: 52px;
  border-radius: 16px;
  display: grid;
  place-items: center;
  background: linear-gradient(135deg, rgba(0, 102, 204, 0.12), rgba(0, 102, 204, 0.04));
  border: 1px solid rgba(0, 102, 204, 0.1);
  box-shadow: 0 10px 30px rgba(30, 64, 175, 0.08);
  flex: 0 0 auto;
}

.ua-hero__mark img {
  width: 30px;
  height: 30px;
}

.ua-hero{
  margin: 0;
  line-height: 1.1;
  font-weight: 700;
}

.ua-hero p {
  margin: 6px 0 0;
  color: #64748b;
  font-size: 0.98rem;
}

.ua-hero__actions {
  display: flex;
  gap: 10px;
  align-items: center;
}

.ua-icon-btn {
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-family: inherit;
}

.ua-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.ua-filter-chip {
  height: 40px;
  border-radius: 12px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: linear-gradient(180deg, #ffffff, #f8fbff);
  color: #334155;
  padding: 0 14px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 0.92rem;
  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);
  font-family: inherit;
}

.ua-filter-chip__chevron {
  margin-left: 2px;
  color: #94a3b8;
}

.ua-filter-chip--date img,
.ua-filter-button img {
  width: 16px;
  height: 16px;
}

.ua-filter-button {
  height: 40px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
}

.show_date_btn {
  border: 1px solid #e4e4e4;
  border-radius: 6px;
  color: #838fb4;
  font-size: 14px;
  font-weight: 400;
  padding: 12px;
  height: 35px;
  font-family: inherit;
}

.filterBtn {
  height: 35px;
}

.ua-legend {
  display: flex;
  gap: 20px;
  align-items: center;
  margin: 8px 0 14px;
  color: #0f172a;
  font-size: 0.92rem;
  flex-wrap: wrap;
}

.ua-legend span {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ua-env-pill {
  padding: 8px 12px;
  border-radius: 999px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 999px;
  display: inline-block;
}

.dot-prod {
  background: #1d4ed8;
}

.dot-nonprod {
  background: #0f9d8f;
}

.ua-snapshot {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}

.ua-snapshot__item {
  border-radius: 16px;
  padding: 14px 16px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.92), rgba(248, 250, 252, 0.95));
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.05);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ua-snapshot__item span {
  font-size: 0.84rem;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ua-snapshot__item strong {
  font-size: 1.3rem;
  color: #0f172a;
  font-weight: 700;
}

.tone-blue {
  border-color: rgba(29, 78, 216, 0.15);
}

.tone-teal {
  border-color: rgba(15, 157, 143, 0.15);
}

.tone-green {
  border-color: rgba(34, 197, 94, 0.15);
}

.tone-indigo {
  border-color: rgba(79, 70, 229, 0.15);
}

.ua-loading {
  min-height: 320px;
  display: grid;
  place-items: center;
}

.ua-sections {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.ua-section__header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}

.ua-section__header h2 {
  margin: 0;
  color: #111827;
  font-size: 1.08rem;
  font-weight: 700;
  font-family: inherit;
}

.ua-section__header::after {
  content: '';
  height: 1px;
  flex: 1 1;
  background: linear-gradient(90deg, rgba(148, 163, 184, 0.35), rgba(148, 163, 184, 0.1));
}

.ua-grid {
  display: grid;
  gap: 12px;
  align-items: start;
}

.ua-grid--4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.ua-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.ua-summary-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.ua-summary-panel {
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  padding: 16px;
}

.ua-summary-panel h3 {
  margin: 0 0 12px;
  color: #111827;
  font-size: 1rem;
  font-weight: 700;
  font-family: inherit;
}

.ua-summary-field {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  border-top: 1px solid rgba(226, 232, 240, 0.8);
}

.ua-summary-field:first-of-type {
  border-top: 0;
  padding-top: 0;
}

.ua-summary-field span {
  color: #64748b;
  font-size: 0.9rem;
  font-family: inherit;
}

.ua-summary-field strong {
  color: #0f172a;
  font-size: 0.95rem;
  font-weight: 700;
  text-align: right;
  font-family: inherit;
}

.ua-warning-box {
  border-radius: 18px;
  border: 1px solid rgba(251, 191, 36, 0.25);
  background: rgba(255, 251, 235, 0.85);
  padding: 16px 18px;
  color: #92400e;
}

.ua-warning-box ul {
  margin: 0;
  padding-left: 18px;
}

.ua-warning-box li + li {
  margin-top: 6px;
}

.ua-card {
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);
  padding: 14px;
  min-height: 152px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.ua-card__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.ua-card__top h3 {
  margin: 0;
  color: #111827;
  font-size: 1rem;
  line-height: 1.35;
  font-weight: 600;
  font-family: inherit;
}

.ua-card__icon {
  width: 38px;
  height: 38px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: rgba(0, 102, 204, 0.08);
  color: #2563eb;
  flex: 0 0 auto;
}

.ua-card__values {
  margin-top: 12px;
  border-radius: 12px;
  overflow: hidden;
}

.ua-card__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
}

.ua-card__row + .ua-card__row {
  border-top: 1px solid rgba(226, 232, 240, 0.8);
}

.ua-card__label {
  color: #2563eb;
  font-size: 0.88rem;
  font-weight: 600;
  font-family: inherit;
}

.ua-card__value {
  font-size: 1rem;
  font-weight: 700;
  font-family: inherit;
}

.ua-card__value.production {
  color: #1d4ed8;
}

.ua-card__value.non-production {
  color: #0f9d8f;
}

.ua-card__value.total {
  color: #4f46e5;
}

.ua-card__value.average {
  color: #7c3aed;
}

.ua-token-card {
  min-height: 220px;
}

.ua-token-card__title {
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
}

.ua-token-info {
  color: #2563eb;
  display: inline-flex;
  cursor: help;
  position: relative;
}

.ua-token-tooltip {
  display: none;
  position: absolute;
  left: 22px;
  top: -12px;
  width: 210px;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: #ffffff;
  color: #1f2937;
  font-size: 0.78rem;
  line-height: 1.45;
  font-weight: 500;
  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18);
  z-index: 5;
}

.ua-token-info:hover .ua-token-tooltip,
.ua-token-info:focus .ua-token-tooltip {
  display: block;
}

.ua-token-card__values {
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: visible;
}

.ua-token-row {
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid transparent;
}

.ua-token-row--production {
  background: rgba(37, 99, 235, 0.06);
  border-color: rgba(37, 99, 235, 0.12);
}

.ua-token-row--non-production {
  background: rgba(15, 157, 143, 0.06);
  border-color: rgba(15, 157, 143, 0.12);
}

.ua-token-row__summary {
  width: 100%;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  font-family: inherit;
}

.ua-token-row__label {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #2563eb;
  font-size: 0.88rem;
  font-weight: 600;
}

.ua-token-row--non-production .ua-token-row__label {
  color: #0f9d8f;
}

.ua-token-row__chevron {
  transition: transform 0.18s ease;
}

.ua-token-row__chevron.open {
  transform: rotate(180deg);
}

.ua-token-row__details {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 10px;
  padding: 8px 10px 10px;
  text-align: center;
}

.ua-token-row__details span {
  display: block;
  color: #64748b;
  font-size: 0.72rem;
  font-weight: 500;
}

.ua-token-row__details strong {
  display: block;
  color: #2563eb;
  font-size: 0.88rem;
  font-weight: 700;
}

.ua-token-row--non-production .ua-token-row__details strong {
  color: #0f9d8f;
}

.ua-token-row__divider {
  width: 1px;
  height: 28px;
  background: rgba(148, 163, 184, 0.45);
}

.ua-token-card__total {
  border-radius: 8px;
  background: rgba(124, 58, 237, 0.06);
}

.accent-blue .ua-card__icon {
  background: rgba(37, 99, 235, 0.1);
  color: #2563eb;
}

.accent-teal .ua-card__icon {
  background: rgba(15, 157, 143, 0.1);
  color: #0f9d8f;
}

.accent-cyan .ua-card__icon {
  background: rgba(6, 182, 212, 0.1);
  color: #0891b2;
}

.accent-indigo .ua-card__icon {
  background: rgba(79, 70, 229, 0.1);
  color: #4f46e5;
}

.accent-violet .ua-card__icon {
  background: rgba(124, 58, 237, 0.1);
  color: #7c3aed;
}

.ua-footer-card {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 18px;
  background: linear-gradient(135deg, rgba(0, 102, 204, 0.08), rgba(15, 157, 143, 0.06));
  border: 1px solid rgba(0, 102, 204, 0.12);
}

.ua-footer-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  background: rgba(255, 255, 255, 0.72);
  color: #2563eb;
  flex: 0 0 auto;
}

.ua-footer-card h3 {
  margin: 0;
  color: #0f172a;
  font-size: 1rem;
  font-weight: 700;
  font-family: inherit;
}

.ua-footer-card p {
  margin: 6px 0 0;
  color: #475569;
  font-size: 0.92rem;
  line-height: 1.55;
  font-family: inherit;
}

@media (max-width: 1280px) {
  .ua-grid--4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .ua-grid--3 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .ua-snapshot {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .ua-summary-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .ua-page {
    padding: 14px;
  }

  .ua-hero {
    flex-direction: column;
  }

  .ua-hero__actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .ua-grid--4,
  .ua-grid--3,
  .ua-snapshot,
  .ua-summary-grid {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Analytics/UnifiedAnalytics.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qFAAqF;EACrF,wCAAwC;EACxC,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,qDAAqD;EACrD,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,2CAA2C;EAC3C,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,yFAAyF;EACzF,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,SAAO;EACP,uFAAuF;AACzF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,6DAA6D;EAC7D,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,6DAA6D;EAC7D,8CAA8C;EAC9C,aAAa;EACb,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,UAAU;AACZ;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,sFAAsF;EACtF,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;;;IAIE,0BAA0B;EAC5B;AACF","sourcesContent":[".ua-page {\n  padding: 18px 22px 26px;\n  font-family: 'Unilever Shilling', sans-serif;\n  font-size: 0.875rem;\n  color: #111111;\n}\n\n.ua-shell {\n  /* max-width: 1500px; */\n  margin: 0 auto;\n}\n\n.ua-hero {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 18px;\n}\n\n.ua-hero__title {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n}\n\n.ua-hero__mark {\n  width: 52px;\n  height: 52px;\n  border-radius: 16px;\n  display: grid;\n  place-items: center;\n  background: linear-gradient(135deg, rgba(0, 102, 204, 0.12), rgba(0, 102, 204, 0.04));\n  border: 1px solid rgba(0, 102, 204, 0.1);\n  box-shadow: 0 10px 30px rgba(30, 64, 175, 0.08);\n  flex: 0 0 auto;\n}\n\n.ua-hero__mark img {\n  width: 30px;\n  height: 30px;\n}\n\n.ua-hero{\n  margin: 0;\n  line-height: 1.1;\n  font-weight: 700;\n}\n\n.ua-hero p {\n  margin: 6px 0 0;\n  color: #64748b;\n  font-size: 0.98rem;\n}\n\n.ua-hero__actions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.ua-icon-btn {\n  height: 40px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  font-family: inherit;\n}\n\n.ua-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 14px;\n}\n\n.ua-filter-chip {\n  height: 40px;\n  border-radius: 12px;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  background: linear-gradient(180deg, #ffffff, #f8fbff);\n  color: #334155;\n  padding: 0 14px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.92rem;\n  box-shadow: 0 1px 0 rgba(15, 23, 42, 0.02);\n  font-family: inherit;\n}\n\n.ua-filter-chip__chevron {\n  margin-left: 2px;\n  color: #94a3b8;\n}\n\n.ua-filter-chip--date img,\n.ua-filter-button img {\n  width: 16px;\n  height: 16px;\n}\n\n.ua-filter-button {\n  height: 40px;\n  border-radius: 12px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n}\n\n.show_date_btn {\n  border: 1px solid #e4e4e4;\n  border-radius: 6px;\n  color: #838fb4;\n  font-size: 14px;\n  font-weight: 400;\n  padding: 12px;\n  height: 35px;\n  font-family: inherit;\n}\n\n.filterBtn {\n  height: 35px;\n}\n\n.ua-legend {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  margin: 8px 0 14px;\n  color: #0f172a;\n  font-size: 0.92rem;\n  flex-wrap: wrap;\n}\n\n.ua-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ua-env-pill {\n  padding: 8px 12px;\n  border-radius: 999px;\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  background: rgba(255, 255, 255, 0.9);\n  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);\n}\n\n.dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 999px;\n  display: inline-block;\n}\n\n.dot-prod {\n  background: #1d4ed8;\n}\n\n.dot-nonprod {\n  background: #0f9d8f;\n}\n\n.ua-snapshot {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.ua-snapshot__item {\n  border-radius: 16px;\n  padding: 14px 16px;\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.92), rgba(248, 250, 252, 0.95));\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.05);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ua-snapshot__item span {\n  font-size: 0.84rem;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.ua-snapshot__item strong {\n  font-size: 1.3rem;\n  color: #0f172a;\n  font-weight: 700;\n}\n\n.tone-blue {\n  border-color: rgba(29, 78, 216, 0.15);\n}\n\n.tone-teal {\n  border-color: rgba(15, 157, 143, 0.15);\n}\n\n.tone-green {\n  border-color: rgba(34, 197, 94, 0.15);\n}\n\n.tone-indigo {\n  border-color: rgba(79, 70, 229, 0.15);\n}\n\n.ua-loading {\n  min-height: 320px;\n  display: grid;\n  place-items: center;\n}\n\n.ua-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.ua-section__header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.ua-section__header h2 {\n  margin: 0;\n  color: #111827;\n  font-size: 1.08rem;\n  font-weight: 700;\n  font-family: inherit;\n}\n\n.ua-section__header::after {\n  content: '';\n  height: 1px;\n  flex: 1;\n  background: linear-gradient(90deg, rgba(148, 163, 184, 0.35), rgba(148, 163, 184, 0.1));\n}\n\n.ua-grid {\n  display: grid;\n  gap: 12px;\n  align-items: start;\n}\n\n.ua-grid--4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.ua-grid--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.ua-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 12px;\n}\n\n.ua-summary-panel {\n  border-radius: 18px;\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);\n  padding: 16px;\n}\n\n.ua-summary-panel h3 {\n  margin: 0 0 12px;\n  color: #111827;\n  font-size: 1rem;\n  font-weight: 700;\n  font-family: inherit;\n}\n\n.ua-summary-field {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 0;\n  border-top: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.ua-summary-field:first-of-type {\n  border-top: 0;\n  padding-top: 0;\n}\n\n.ua-summary-field span {\n  color: #64748b;\n  font-size: 0.9rem;\n  font-family: inherit;\n}\n\n.ua-summary-field strong {\n  color: #0f172a;\n  font-size: 0.95rem;\n  font-weight: 700;\n  text-align: right;\n  font-family: inherit;\n}\n\n.ua-warning-box {\n  border-radius: 18px;\n  border: 1px solid rgba(251, 191, 36, 0.25);\n  background: rgba(255, 251, 235, 0.85);\n  padding: 16px 18px;\n  color: #92400e;\n}\n\n.ua-warning-box ul {\n  margin: 0;\n  padding-left: 18px;\n}\n\n.ua-warning-box li + li {\n  margin-top: 6px;\n}\n\n.ua-card {\n  border-radius: 18px;\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.06);\n  padding: 14px;\n  min-height: 152px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.ua-card__top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.ua-card__top h3 {\n  margin: 0;\n  color: #111827;\n  font-size: 1rem;\n  line-height: 1.35;\n  font-weight: 600;\n  font-family: inherit;\n}\n\n.ua-card__icon {\n  width: 38px;\n  height: 38px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  background: rgba(0, 102, 204, 0.08);\n  color: #2563eb;\n  flex: 0 0 auto;\n}\n\n.ua-card__values {\n  margin-top: 12px;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.ua-card__row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 12px;\n}\n\n.ua-card__row + .ua-card__row {\n  border-top: 1px solid rgba(226, 232, 240, 0.8);\n}\n\n.ua-card__label {\n  color: #2563eb;\n  font-size: 0.88rem;\n  font-weight: 600;\n  font-family: inherit;\n}\n\n.ua-card__value {\n  font-size: 1rem;\n  font-weight: 700;\n  font-family: inherit;\n}\n\n.ua-card__value.production {\n  color: #1d4ed8;\n}\n\n.ua-card__value.non-production {\n  color: #0f9d8f;\n}\n\n.ua-card__value.total {\n  color: #4f46e5;\n}\n\n.ua-card__value.average {\n  color: #7c3aed;\n}\n\n.ua-token-card {\n  min-height: 220px;\n}\n\n.ua-token-card__title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  position: relative;\n}\n\n.ua-token-info {\n  color: #2563eb;\n  display: inline-flex;\n  cursor: help;\n  position: relative;\n}\n\n.ua-token-tooltip {\n  display: none;\n  position: absolute;\n  left: 22px;\n  top: -12px;\n  width: 210px;\n  padding: 12px 14px;\n  border-radius: 8px;\n  border: 1px solid rgba(148, 163, 184, 0.35);\n  background: #ffffff;\n  color: #1f2937;\n  font-size: 0.78rem;\n  line-height: 1.45;\n  font-weight: 500;\n  box-shadow: 0 12px 28px rgba(15, 23, 42, 0.18);\n  z-index: 5;\n}\n\n.ua-token-info:hover .ua-token-tooltip,\n.ua-token-info:focus .ua-token-tooltip {\n  display: block;\n}\n\n.ua-token-card__values {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  overflow: visible;\n}\n\n.ua-token-row {\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid transparent;\n}\n\n.ua-token-row--production {\n  background: rgba(37, 99, 235, 0.06);\n  border-color: rgba(37, 99, 235, 0.12);\n}\n\n.ua-token-row--non-production {\n  background: rgba(15, 157, 143, 0.06);\n  border-color: rgba(15, 157, 143, 0.12);\n}\n\n.ua-token-row__summary {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 10px;\n  font-family: inherit;\n}\n\n.ua-token-row__label {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  color: #2563eb;\n  font-size: 0.88rem;\n  font-weight: 600;\n}\n\n.ua-token-row--non-production .ua-token-row__label {\n  color: #0f9d8f;\n}\n\n.ua-token-row__chevron {\n  transition: transform 0.18s ease;\n}\n\n.ua-token-row__chevron.open {\n  transform: rotate(180deg);\n}\n\n.ua-token-row__details {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 10px 10px;\n  text-align: center;\n}\n\n.ua-token-row__details span {\n  display: block;\n  color: #64748b;\n  font-size: 0.72rem;\n  font-weight: 500;\n}\n\n.ua-token-row__details strong {\n  display: block;\n  color: #2563eb;\n  font-size: 0.88rem;\n  font-weight: 700;\n}\n\n.ua-token-row--non-production .ua-token-row__details strong {\n  color: #0f9d8f;\n}\n\n.ua-token-row__divider {\n  width: 1px;\n  height: 28px;\n  background: rgba(148, 163, 184, 0.45);\n}\n\n.ua-token-card__total {\n  border-radius: 8px;\n  background: rgba(124, 58, 237, 0.06);\n}\n\n.accent-blue .ua-card__icon {\n  background: rgba(37, 99, 235, 0.1);\n  color: #2563eb;\n}\n\n.accent-teal .ua-card__icon {\n  background: rgba(15, 157, 143, 0.1);\n  color: #0f9d8f;\n}\n\n.accent-cyan .ua-card__icon {\n  background: rgba(6, 182, 212, 0.1);\n  color: #0891b2;\n}\n\n.accent-indigo .ua-card__icon {\n  background: rgba(79, 70, 229, 0.1);\n  color: #4f46e5;\n}\n\n.accent-violet .ua-card__icon {\n  background: rgba(124, 58, 237, 0.1);\n  color: #7c3aed;\n}\n\n.ua-footer-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 16px 18px;\n  border-radius: 18px;\n  background: linear-gradient(135deg, rgba(0, 102, 204, 0.08), rgba(15, 157, 143, 0.06));\n  border: 1px solid rgba(0, 102, 204, 0.12);\n}\n\n.ua-footer-card__icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  background: rgba(255, 255, 255, 0.72);\n  color: #2563eb;\n  flex: 0 0 auto;\n}\n\n.ua-footer-card h3 {\n  margin: 0;\n  color: #0f172a;\n  font-size: 1rem;\n  font-weight: 700;\n  font-family: inherit;\n}\n\n.ua-footer-card p {\n  margin: 6px 0 0;\n  color: #475569;\n  font-size: 0.92rem;\n  line-height: 1.55;\n  font-family: inherit;\n}\n\n@media (max-width: 1280px) {\n  .ua-grid--4 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .ua-grid--3 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .ua-snapshot {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .ua-summary-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .ua-page {\n    padding: 14px;\n  }\n\n  .ua-hero {\n    flex-direction: column;\n  }\n\n  .ua-hero__actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .ua-grid--4,\n  .ua-grid--3,\n  .ua-snapshot,\n  .ua-summary-grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
